const CART_PRODUCT_METAFIELDS_TUNE = `#graphql
  fragment CartProductMetafieldsTune on Product {
    quantityLimit: metafield(namespace: "custom", key: "quantity_limit_variant") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "custom", key: "quantity_limit") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "notice", key: "content") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

const CART_PRODUCT_METAFIELDS_THISISNEVERTHAT = `#graphql
  fragment CartProductMetafieldsThisisneverthat on Product {
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "notice", key: "content") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

const CART_PRODUCT_METAFIELDS_KHAKIS = `#graphql
  fragment CartProductMetafieldsKhakis on Product {
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "notice", key: "content") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

const CART_PRODUCT_METAFIELDS_YESEYESEE = `#graphql
  fragment CartProductMetafieldsYeseyesee on Product {
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "info", key: "notice") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

const CART_PRODUCT_METAFIELDS_SUNLOVE = `#graphql
  fragment CartProductMetafieldsSunlove on Product {
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "info", key: "notice") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

const CART_PRODUCT_METAFIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CartProductMetafieldsWellbeingexpress on Product {
    quantityLimit: metafield(namespace: "operation", key: "quantity_limit") {
      ...MetafieldFields
    }
    quantityLimitProduct: metafield(namespace: "operation", key: "quantity_limit_product") {
      ...MetafieldFields
    }
    notice: metafield(namespace: "info", key: "notice") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

/** 스토어 공통으로 붙는 카트 Product metafield */
const CART_PRODUCT_COMMON_METAFIELDS = `#graphql
  fragment CartProductCommonMetafields on Product {
    availableCountries: metafield(namespace: "operation", key: "available_countries") {
      ...MetafieldFields
    }
    unavailableCountries: metafield(namespace: "operation", key: "unavailable_countries") {
      ...MetafieldFields
    }
    sale: metafield(namespace: "familysale", key: "sale") {
      ...MetafieldFields
    }
    brandName: metafield(namespace: "info", key: "brand_name") {
      ...MetafieldFields
    }
    thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
      ...MetafieldFields
      reference {
        ...MediaImageFields
      }
      references(first: 10) {
        edges {
          node {
            ...MediaImageFields
          }
        }
      }
    }
  }
`;

/* ------------------------------------------------------------------ *
 * 카트 라인의 merchandise (ProductVariant) — 스토어별
 * ------------------------------------------------------------------ */

const CART_MERCHANDISE_TUNE = `#graphql
  fragment CartMerchandiseTune on ProductVariant {
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
    ...VariantBaseFields
    product {
      ...ProductFieldsTune
      ...CartProductMetafieldsTune
    }
  }
`;

const CART_MERCHANDISE_YESEYESEE = `#graphql
  fragment CartMerchandiseYeseyesee on ProductVariant {
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
    ...VariantBaseFields
    product {
      ...ProductCommonFields
      ...CartProductMetafieldsYeseyesee
    }
  }
`;

const CART_MERCHANDISE_THISISNEVERTHAT = `#graphql
  fragment CartMerchandiseThisisneverthat on ProductVariant {
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
    ...VariantBaseFields
    product {
      ...ProductCommonFields
      ...CartProductMetafieldsThisisneverthat
    }
  }
`;

const CART_MERCHANDISE_KHAKIS = `#graphql
  fragment CartMerchandiseKhakis on ProductVariant {
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
    ...VariantBaseFields
    product {
      ...ProductCommonFields
      ...CartProductMetafieldsKhakis
    }
  }
`;

const CART_MERCHANDISE_SUNLOVE = `#graphql
  fragment CartMerchandiseSunlove on ProductVariant {
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
    ...VariantBaseFields
    product {
      ...ProductCommonFields
      ...CartProductMetafieldsSunlove
    }
  }
`;

const CART_MERCHANDISE_WELLBEINGEXPRESS = `#graphql
  fragment CartMerchandiseWellbeingexpress on ProductVariant {
    brandVariantId: metafield(namespace: "familysale", key: "brand_variant_id") {
      ...MetafieldFields
    }
    ...VariantBaseFields
    product {
      ...ProductFieldsWellbeingexpress
      ...CartProductMetafieldsWellbeingexpress
    }
  }
`;

/* ------------------------------------------------------------------ *
 * 카트 본문에서 merchandise를 제외한 공통 선택자
 * (스토어별 CartFields{Store}에서 spread 해서 사용)
 * ------------------------------------------------------------------ */

const CART_COMMON_FIELDS = `#graphql
  fragment CartCommonFields on Cart {
    id
    totalQuantity
    attributes {
      ...AttributeFields
    }
    buyerIdentity {
      countryCode
      email
      phone
      customer {
        ...CustomerBaseFields
      }
    }
    discountAllocations {
      ...CartCustomDiscountAllocationFields
      ...CartCodeDiscountAllocationFields
      ...CartAutomaticDiscountAllocationFields
    }
    discountCodes {
      applicable
      code
    }
    cost {
      checkoutChargeAmount {
        ...MoneyFields
      }
      subtotalAmount {
        ...MoneyFields
      }
      totalAmount {
        ...MoneyFields
      }
      totalDutyAmount {
        ...MoneyFields
      }
      totalTaxAmount {
        ...MoneyFields
      }
    }
    checkoutUrl
    createdAt
    note
    updatedAt
    deliveryGroups(first: 50) {
      edges {
        node {
          id
          deliveryOptions {
            title
            deliveryMethodType
            estimatedCost {
              amount
            }
          }
        }
      }
    }
  }
`;

/** 카트 라인 (merchandise 제외) 공통 선택자 */
const CART_LINE_COMMON_FIELDS = `#graphql
  fragment CartLineCommonFields on BaseCartLine {
    id
    quantity
    attributes {
      key
      value
    }
    cost {
      amountPerQuantity {
        ...MoneyFields
      }
      compareAtAmountPerQuantity {
        ...MoneyFields
      }
      subtotalAmount {
        ...MoneyFields
      }
      totalAmount {
        ...MoneyFields
      }
    }
    discountAllocations {
      ...CartCodeDiscountAllocationFields
      ...CartCustomDiscountAllocationFields
      ...CartAutomaticDiscountAllocationFields
    }
  }
`;

/* ------------------------------------------------------------------ *
 * 스토어별 전체 Cart fragment (구조 동일, merchandise fragment만 교체)
 * ------------------------------------------------------------------ */

const CART_FIELDS_TUNE = `#graphql
  fragment CartFieldsTune on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseTune
            }
          }
        }
      }
    }
  }
`;

const CART_FIELDS_YESEYESEE = `#graphql
  fragment CartFieldsYeseyesee on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseYeseyesee
            }
          }
        }
      }
    }
  }
`;

const CART_FIELDS_THISISNEVERTHAT = `#graphql
  fragment CartFieldsThisisneverthat on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseThisisneverthat
            }
          }
        }
      }
    }
  }
`;

const CART_FIELDS_KHAKIS = `#graphql
  fragment CartFieldsKhakis on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseKhakis
            }
          }
        }
      }
    }
  }
`;

const CART_FIELDS_SUNLOVE = `#graphql
  fragment CartFieldsSunlove on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseSunlove
            }
          }
        }
      }
    }
  }
`;

const CART_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CartFieldsWellbeingexpress on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseWellbeingexpress
            }
          }
        }
      }
    }
  }
`;

/** 이 파일의 모든 fragment (registry 등록용) */
/**
 * tenui 카트는 hydrogen 시절에도 상품 메타필드를 거의 쓰지 않았다.
 * (CART_FRAGMENT 의 merchandise 는 variant 기본 필드 + product handle/title/tags 뿐)
 */
const CART_PRODUCT_METAFIELDS_TENUI = `#graphql
  fragment CartProductMetafieldsTenui on Product {
    cardTag: metafield(namespace: "info", key: "card_tag") {
      ...MetafieldFields
    }
    ...CartProductCommonMetafields
  }
`;

const CART_MERCHANDISE_TENUI = `#graphql
  fragment CartMerchandiseTenui on ProductVariant {
    ...VariantBaseFields
    product {
      ...ProductCommonFields
      ...CartProductMetafieldsTenui
    }
  }
`;

const CART_FIELDS_TENUI = `#graphql
  fragment CartFieldsTenui on Cart {
    ...CartCommonFields
    lines(first: 50) {
      edges {
        node {
          ...CartLineCommonFields
          merchandise {
            ... on ProductVariant {
              ...CartMerchandiseTenui
            }
          }
        }
      }
    }
  }
`;

export const CART_FRAGMENTS = [
  CART_PRODUCT_METAFIELDS_TUNE,
  CART_PRODUCT_METAFIELDS_THISISNEVERTHAT,
  CART_PRODUCT_METAFIELDS_KHAKIS,
  CART_PRODUCT_METAFIELDS_YESEYESEE,
  CART_PRODUCT_METAFIELDS_SUNLOVE,
  CART_PRODUCT_METAFIELDS_WELLBEINGEXPRESS,
  CART_PRODUCT_COMMON_METAFIELDS,
  CART_MERCHANDISE_TUNE,
  CART_MERCHANDISE_YESEYESEE,
  CART_MERCHANDISE_THISISNEVERTHAT,
  CART_MERCHANDISE_KHAKIS,
  CART_MERCHANDISE_SUNLOVE,
  CART_MERCHANDISE_WELLBEINGEXPRESS,
  CART_COMMON_FIELDS,
  CART_LINE_COMMON_FIELDS,
  CART_FIELDS_TUNE,
  CART_FIELDS_YESEYESEE,
  CART_FIELDS_THISISNEVERTHAT,
  CART_FIELDS_KHAKIS,
  CART_FIELDS_SUNLOVE,
  CART_FIELDS_WELLBEINGEXPRESS,
  CART_PRODUCT_METAFIELDS_TENUI,
  CART_MERCHANDISE_TENUI,
  CART_FIELDS_TENUI,
];
